import { Skeleton } from "@musa.tech/design-system";

/**
 * Skeletons de carregamento do módulo Financeiro.
 *
 * O @musa.tech/design-system expõe apenas o átomo `Skeleton` — não há
 * `TableSkeleton`/`CardSkeleton` exportados. Estes helpers seguem o padrão
 * documentado no knowledge do Design System (composição com `Skeleton`).
 */

export function TableSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="space-y-2 px-4 md:px-6 pb-4">
      <Skeleton className="h-12 w-full" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  );
}

export function DocumentSkeleton() {
  return <Skeleton className="h-[520px] w-full rounded-md" />;
}
